import React, { Component } from 'react'
import WorkCanvas from './WorkCanvas';
import {AnimatePresence, motion} from "framer-motion/dist/framer-motion";
import { Link } from 'react-router-dom';

const FightorDie = () => {
  const containervariants = {
    hidden : {opacity: 0, x: "100%"}, 
    visible : { opacity: 1, x: "0%",
    transition :{ease:"easeInOut", type: "spring",
    stiffness: 260, damping: 20} }, 
    exit:{ x: "-100%", transition:{ ease: "easeInOut"} }
   } 
   return (

<motion.div className="workcontainer" variants={containervariants} initial="hidden" animate="visible" exit="exit">
  <div className="workcontentholder">
 <div className="overlaytextholder">
  <h2 className="Workmaintitle"><span>‘Fight or Die’ <br></br> Poster Series</span></h2>
  <p className= "Workmainpara"><span>The way t shirts is a fitness and martial arts clothing brand.<br></br><br></br>
        The assignment was to create a series of minimalist posts inline with the brand, that would bring out the fighting spirit that it embodies.  
        </span></p>
  </div> 
<div className="workcanvasholder">
<WorkCanvas id={"starwars1"} width={600} height={1000}></WorkCanvas>
</div>
</div>
<div className="rightcontentsection fightsectionright">
  <div className="workcontenttheway1">
    <img className="workimgtheway1" src={require("./images/FIGHT OR DIE 1.png").default} alt="" />
    </div>
  <div className="workcontenttheway2">
  <img className='workimgtheway' src={require("./images/FIGHT OR DIE 2.png").default} alt="" />
  </div>
  <div className="workcontenttheway3">
  <img className='workimgtheway' src={require("./images/FIGHT OR DIE 3.png").default} alt="" />
  </div>
  <div className="workcontenttheway4">
  <img className='workimgtheway' src={require("./images/FIGHT OR DIE 4.png").default} alt="" />
  </div>
  <div className="workcontenttheway5">
  <img className='workimgtheway1' src={require("./images/FIGHT OR DIE 5.png").default} alt="" />
  </div>
  <div className="arrowsection">
  <Link className="linknext" to="/trans">
  <img className="Arrowimages" src={require("./images/nextproject.png").default} alt="" />
  <img className="Arrowimages" src={require("./images/aroows.png").default} alt="" />
  </Link>
  </div>
</div>

<svg xmlns="http://www.w3.org/2000/svg" version="1.1">
  <defs>
    <filter id="gooeysvg">
      <feGaussianBlur in="SourceGraphic" stdDeviation="10" result="blur" />
      <feColorMatrix in="blur" mode="matrix"
        values=" 1 0 0 0 0
                 0 1 0 0 0
                 0 0 1 0 0
                 0 0 0 20 -7" result="gooeysvg" />
      <feComposite in="SourceGraphic" in2="gooeysvg" operator="atop"/>
    </filter>
  </defs>
</svg>
</motion.div>  

    );
}
 
export default FightorDie;